/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { DialogRef, DialogService } from '@gh/core-ui';
import { of$ } from '@gh/rx';
import { filter$ } from '@gh/rx/operators';

import { Observable } from 'rxjs';
import {
  AuthNumberGenerationConfig,
  AuthNumberGenerationDialogComponent,
  AuthNumberRequestConfig,
} from '../auth-number';
import { authNumberRequestDialogRoute } from '../auth-number/components/auth-number-request-dialog/auth-number-request-dialog.route';
import { BuilderUserContext } from '../user/builder-user-context';

@Injectable()
export class BuilderAuthNumberService {

  constructor(protected router: Router,
              protected dialogService: DialogService,
              private userContext: BuilderUserContext) {

  }

  openAuthNumberRequest(entryPoint: string): Observable<Maybe<string>> {
    if (!this.userContext.isSwitched()) {
      // @ts-ignore
      return this.dialogService.openWithInput(authNumberRequestDialogRoute, <AuthNumberRequestConfig>{
        entryPoint,
      }).afterClosed().pipe(filter$(Boolean));
    } else {
      return of$(void 0);
    }
  }

  openAuthNumberGeneration(): DialogRef<AuthNumberGenerationDialogComponent> {
    return this.dialogService.openWithInput(AuthNumberGenerationDialogComponent, <AuthNumberGenerationConfig>{});
  }
}
